import { SegmentedNav } from "../../../common/components/SegmentedNav";
import type { MeSectionNavigationProps } from "../types";

const sections = [
  { id: "activity", label: "Activity", to: "/me" },
  { id: "performance", label: "Performance", to: "/me/performance" },
  { id: "account", label: "Account", to: "/me/account" },
] as const;

export function MeSectionNavigation({ active }: MeSectionNavigationProps) {
  return <SegmentedNav label="Me sections" items={sections} active={active} />;
}
